import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'

export const TRANSACTION_CONFIRM = (cpf, msisdn) => `/cliente/${onlyNumbers(cpf)}/${onlyNumbers(msisdn)}/confirm`
export const TRANSACTION_VERIFY = (transactionId) => `/transaction/${transactionId}`
